import React from "react";

function CardDataLabelComponent(props) {
    const color = { color: props.color ? props.color : '#000' }
    return (
        <div className="mb-2">
            {props.title ? (
                <label htmlFor={props.id} style={color} className="card-data-title">{props.label}</label>
            ) : (
                <>
                    {props.bold ?
                            <label htmlFor={props.id} className="card-data-label"><strong>{props.label}</strong></label>
                            : <label htmlFor={props.id} className="card-data-label">{props.label}</label>}
                </>
            )}
            
        </div>
    );
}

export default CardDataLabelComponent;









